<template>
  <div class="programsComp">
    <tbl-comp
        :model="this.$store.getters[`${this.moduleName}/getModel`]"
        :paging="true"
        :rowClick="rowClick"
        :moduleName="moduleName"
        :btnAdd="role == 'dealer'"
        :searchInput="false"
    />
  </div>
</template>

<script>
export default {
  name: 'programsComp',
  props: {},
  data: function () {
    return {
      moduleName: 'programs'
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/setModelRequired`, { required: this.required })
  },
  components: {},
  computed: {
    // required: function() { return localStorage.getItem('role') == 'admin' ? ['id', 'countMinutes', 'price', 'dealerIdMysql'] : ['id', 'countMinutes', 'price'] },
    required: function () {
      return localStorage.getItem('role') == 'admin' ? ['id', 'countMinutes', 'dealerIdMysql'] : ['id', 'countMinutes']
    },
    role: function () {
      return localStorage.getItem('role')
    }
  },
  methods: {
    rowClick (row) {
      this.$store.dispatch(`${this.moduleName}/toUpdate`, { id: row.id })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
